<div
  class="container-button fixed-bottom"
  [ngStyle]="scrollTop > 0 ? { display: 'block' } : { display: 'none' }"
  [style.bottom]="bottom + 'px'"
>
  <button class="button-ride-up position-sticky" (click)="scrollToTop()">
    <i class="bi bi-arrow-up icon_up"></i>
  </button>
</div>
